fragment InboundEmailRulesFragment on InboundEmailRules {
    assignment {
        strategy
        assignedUser {
            id
            name
        }
    }
    leadCreation {
        enabled
        stageset {
            id
            name
        }
        tags {
            id
            name
        }
    }
}
